import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FooterButtonGroup } from './FooterButtonGroup';

export const WorkflowPopup = ({ tc, copyOption, closeDialog, proceedToNextCopyDataModal, handleRadioButtonChange }) => {
  return (
    <Fragment>
      <RadioGroup aria-label="copyInformation" name="copyInformation" value={copyOption} onChange={handleRadioButtonChange} className="CVRadioGroup">
        <div className="CVRadioWrapper">
          <FormControlLabel
            value={'BB'}
            control={<Radio color="default" checked={copyOption === 'BB'} />}
            label={<span style={{ fontSize: '14px' }}>{tc('BEGINNING_BALANCE')}</span>}
          />
          <FormControlLabel
            value={'PD'}
            control={<Radio color="default" checked={copyOption === 'PD'} />}
            label={<span style={{ fontSize: '14px' }}>{tc('PERIOD_DATA')}</span>}
          />
        </div>
      </RadioGroup>
      <FooterButtonGroup
        tc={tc}
        actionButtonId="nextButton"
        actionButtonLabel="BUTTON_NEXT"
        actionButtonDisabled={copyOption === ''}
        actionButtonOnClick={() => proceedToNextCopyDataModal(copyOption)}
        cancelButtonOnClick={closeDialog}
      />
    </Fragment>
  );
};

WorkflowPopup.propTypes = {
  tc: PropTypes.func,
  closeDialog: PropTypes.func,
  proceedToNextCopyDataModal: PropTypes.func,
  copyOption: PropTypes.string,
  handleRadioButtonChange: PropTypes.func,
};